<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}:{{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" :busy="isBusy" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template v-slot:cell(denominazionePresidio)="{ item }">
                        <span>{{ item.denominazionePresidio }} </span>
                        <span class="sa-label-data-secondary"> </span>
                    </template>
                    <template v-slot:cell(nome)="{ item }">
                        <span>{{ item.nome }} </span>
                        <span class="sa-label-data-secondary"> </span>
                    </template>
                    <template v-slot:cell(descrizione)="{ item }">
                        <span>{{ item.descrizione }} </span>
                        <span class="sa-label-data-secondary"> </span>
                    </template>
                    <template v-slot:cell(stato)="{ item }">
                        <span>{{ item.stato }} </span>
                        <span class="sa-label-data-secondary"> </span>
                    </template>
                    <template v-slot:cell(enablePrintFolder)="{ item }">
                        <div v-if="item.enablePrintFolder">
                            <b-icon icon="check-square-fill" variant="success"></b-icon>
                        </div>
                        <div v-else>
                            <b-icon icon="x-square-fill" variant="danger"></b-icon>
                        </div>
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button v-b-tooltip.hover size="sm" variant="outline-success" title="Modifica Diario" @click="onEdit(row.item, row.index, $event.target)" class="mr-1 no-text">
                                <font-awesome-icon icon="edit"> </font-awesome-icon>
                            </b-button>
                            <b-button v-if="!row.item.fisso" v-b-tooltip.hover size="sm" variant="outline-danger" title="Cancella Diario" @click="onDelete(row.item, row.index, $event.target)" class="mr-1 no-text">
                                <font-awesome-icon icon="trash"></font-awesome-icon>
                            </b-button>
                            <condivisione-modal :idRisorsa="row.item.id" idSezione="rsadiari"></condivisione-modal>
                            <b-button v-b-tooltip.hover size="sm" variant="outline-info" title="Associa Presidio" @click="onAssociaPresidio(row.item, row.index, $event.target)" class="mr-1 no-text">
                                <font-awesome-icon icon="building" />
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <associa-presidi-modal-component ref="cmpAssociaPresidiModal" @afterSave="onAfterSave"></associa-presidi-modal-component>
    </div>
</template>
<script>
import axios from "axios";
import CondivisioneModal from "../../../utility/components/CondivisioneModal.vue";
import AssociaPresidiModalComponent from "../../../strutture/strutturepresidi/components/AssociaDiariPresidiModalComponent.vue";
export default {
    components: { CondivisioneModal, AssociaPresidiModalComponent },
    data() {
        return {
            filtroConfigurazioneDiari: {},
            pathResource: "/rsadiari",
            showModalLoading: false,
            show: true,
            perPage: 25,
            currentPage: 1,
            rows: 0,
            rowsUsers: 0,
            listKey: 0,
            isBusy: false,
            items: [],
            statoOption: [
                { value: null, text: "- STATO -" },
                { value: "ATTIVO", text: "ATTIVO" },
                { value: "DISATTIVO", text: "DISATTIVO" },
                { value: "SOSPESO", text: "SOSPESO" },
            ],
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                { label: "Presidio", key: "denominazionePresidio", sortable: true },
                { label: "Nome", key: "nome", sortable: true },
                { label: "Descrizione", key: "descrizione", sortable: true },
                { label: "Stato", key: "stato", sortable: true },
                { label: "Presente in Cartella", key: "enablePrintFolder", sortable: true },
                {
                    label: "Posizione",
                    key: "position",
                    sortable: true,
                    thStyle: "width: 10rem",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        loadData() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroConfigurazioneDiari"]) {
                me.filtroConfigurazioneDiari = JSON.parse(sessionStorage["filtroConfigurazioneDiari"]);
                me.$emit("updateFilter", me.filtroConfigurazioneDiari);
            }
            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            me.filtroConfigurazioneDiari.page = me.currentPage;
            me.filtroConfigurazioneDiari.forPage = me.perPage;
            me.$emit("beforeLoadData");
            axios
                .get(link, { params: me.filtroConfigurazioneDiari })
                .then((response) => {
                    me.rows = response.data.data.recordsNumber;
                    me.items = response.data.data.list;
                    me.listKey++;
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onEdit(item) {
            let me = this;
            me.$router.push("/rsaconfigurazionediari/edit/" + item.id);
        },
        onDelete(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler Eliminare il diario " + item.nome)
                .then((value) => {
                    if (value) {
                        let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
                        axios.delete(link + item.id).then(() => {
                            me.loadData();
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        onAssociaPresidio(item) {
            let me = this;
            me.$refs.cmpAssociaPresidiModal.init(item.id);
        },
        onAfterSave() {
            let me = this;
            me.loadData();
        },
    },
};
</script>
